module.exports = __webpack_public_path__ + "static/media/icon-selected.350511e9.svg";